import { defineStore } from "pinia"
import { ref } from 'vue'

export const useExternalTransitionStore = defineStore('externalTransition', () => {
  const confirming = ref(false)
  const externalUrl = ref('')

  const doConfirm = (url: string) => {
    externalUrl.value = url;
    confirming.value = true;
  }
  const confirmed = () => {
    confirming.value = false;
  }

  return {
    confirming,
    externalUrl,
    doConfirm,
    confirmed,
  }
})
